"use client";

import React from "react";
var __jsx = React.createElement;
import APP_CONFIGURATION from "@lib/app.config";
import { useCustomer } from "@lib/context/shared/customer-context";
import { getCssModulesServer } from "@lib/util/get-css-modules-server";
import PageContainer from "@modules/layout/components/shared/container";
import LoadingAnimation from "@modules/shared/animations/loading";
import EntityLogo from "@modules/shared/logos/entity-logo";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
export default function BancoGeneralLanding() {
  var _cssModules$landingCl;
  const t = useTranslations();
  const {
    isInitializingWithUrlRouteToken,
    customerIsLogged
  } = useCustomer();
  const {
    loader_description_text
  } = APP_CONFIGURATION.colors.landing;
  const {
    0: isInitialLoad,
    1: setIsInitialLoad
  } = useState(true);
  const {
    0: showThankYouMessage,
    1: setShowThankYouMessage
  } = useState(false);
  const cssModules = getCssModulesServer();
  const {
    mainContainer,
    contentContainer,
    redirectingContainer,
    exitContainer
  } = (_cssModules$landingCl = cssModules === null || cssModules === void 0 ? void 0 : cssModules.landingClosed) !== null && _cssModules$landingCl !== void 0 ? _cssModules$landingCl : {};
  useEffect(() => {
    if (!isInitialLoad) {
      if (!customerIsLogged && !isInitializingWithUrlRouteToken) {
        setShowThankYouMessage(true);
      }
    } else {
      if (!customerIsLogged && !isInitializingWithUrlRouteToken) {
        setShowThankYouMessage(true);
      }
      setIsInitialLoad(false);
    }
  }, [customerIsLogged, isInitializingWithUrlRouteToken, isInitialLoad]);
  return __jsx(PageContainer, null, __jsx("div", {
    className: mainContainer
  }, __jsx("div", {
    className: contentContainer
  }, (isInitializingWithUrlRouteToken || customerIsLogged) && !showThankYouMessage ? __jsx(React.Fragment, null, __jsx(LoadingAnimation, {
    height: 100,
    color: APP_CONFIGURATION.colors.primary_main,
    loadingApp: false,
    canForceEntityLoader: true
  }), __jsx("div", {
    className: redirectingContainer
  }, __jsx("h1", {
    className: loader_description_text
  }, t("Shared.REDIRECTING_TO_EXTERNAL_ENTITY")))) : __jsx("div", {
    className: exitContainer
  }, __jsx(EntityLogo, {
    height: 48
  }), __jsx("h1", {
    className: loader_description_text
  }, t("Shared.THANK_YOU_FOR_VISITING"))))));
}